import { Box, Text, TextButton } from '@wix/design-system';
import { SwitchProductModule } from '@wix/package-picker-sdk';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';

export const SwitchPlanHeaderBanner = () => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();
  const { data: currentProductData, isLoading: isCurrentProductLoading } =
    SwitchProductModule.SDK.switchApiClient.hooks.useGetCurrentProduct({});

  const { currentProduct, isCurrentProductInOffering } =
    currentProductData ?? {};

  const monthlyPrice = currentProduct?.pricing?.monthlyTotal?.formattedAmount;

  if (
    isCurrentProductLoading ||
    !currentProduct ||
    isCurrentProductInOffering
  ) {
    return null;
  }

  const handleViewCurrentPlanModal = () => {
    const { bi } = EclipsePackagePickerModule.internals;
    SwitchProductModule.SDK.modalsController.PlanFeaturesModal.show({
      onClose: () => {
        bi.onPlanFeaturesModalClose?.({});
      },
      onShow: () => {
        bi.onPlanFeaturesModalShow?.({});
      },
    });
  };

  const bannerKey = monthlyPrice
    ? 'premium-purchase-plan.change-plan-sunrise.banner'
    : 'premium-purchase-plan.change-plan.banner';

  return (
    <Box
      align="center"
      width="100%"
      gap="SP1"
      minHeight="48px"
      maxHeight="48px"
      verticalAlign="middle"
    >
      <Text size="medium">
        {t(bannerKey, {
          planName: currentProduct?.productName,
          originalPlanPrice: monthlyPrice,
        })}
      </Text>
      <TextButton size="medium" onClick={handleViewCurrentPlanModal}>
        {t('change_plan.header.view_current_plan_advanced')}
      </TextButton>
    </Box>
  );
};
